import { useQuery as defaultUseQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
export const appLogoQuery = gql `
  query upsells_appLogoQuery($appName: ID!) {
    app: appByCurrentImplementationId(id: $appName) {
      id
      image
    }
  }
`;
export const useAppLogo = ({ appName, skip = false, useQuery }) => {
    var _a;
    const _useQuery = useQuery || defaultUseQuery;
    const { data, error, loading } = _useQuery(appLogoQuery, {
        skip: skip || !appName,
        variables: {
            appName,
        },
    });
    return {
        appLogoUrl: (_a = data === null || data === void 0 ? void 0 : data.app) === null || _a === void 0 ? void 0 : _a.image,
        error: error === null || error === void 0 ? void 0 : error.message,
        isLoading: loading,
    };
};

// @zapier/upsells@8.0.3 (1de7a616e)
